<template>
    <integration-launch-control is-onboarding-integration/>
</template>

<script>
import {defineComponent} from 'vue'
import IntegrationLaunchControl from "../../settings/integrations/IntegrationLaunchControl.vue";

export default defineComponent({
  name: "OnboardingStepLaunchControl",
  components: {IntegrationLaunchControl},
})
</script>

<style scoped lang="scss">

</style>
